import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

export const ClientOnlyLazySearchEventsRefinements = clientOnlyLazy(() =>
  import('./SearchEventsRefinements').then((m) => ({
    default: m.SearchEventsRefinements,
  })),
);
